import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const ProductsWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default ProductsWrapper